import React, { useState, useEffect } from 'react';
import { Result, Checkbox, Input, Row, Col, Select, Divider, Form, Modal, Spin, Button, Icon, Tag, Table, Tabs, Skeleton, message } from 'antd';
import { copyEmail, getContacts, getCandidates, getClients, getEmails } from './../API';
import moment from 'moment';
import { s3, stripBody, EVENT_TYPE } from './../utils';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { flexCenterRight } from './../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { faInbox } from '@fortawesome/free-solid-svg-icons'
import CustomAvatar from './../components/customAvatar';
import parse from 'html-react-parser';
import { navigate } from "@reach/router"

const { orderBy } = require('lodash');

const { TabPane } = Tabs;
const { Option } = Select;

function Emails({form}) {
  const eventsTypeArr = orderBy(Object.keys(EVENT_TYPE).map(e => {
    return EVENT_TYPE[e]
  }));

  const { getFieldDecorator } = form;

  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const emails = useMappedState(state => state.emails);

  const [personType, setPersonType] = useState('');
  const [clients, setClients] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [candidates, setCandidates] = useState([]);

  const [detail, setDetail] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [reloading, setReloading] = useState(false);

  const [creating, setCreating] = useState(false);

  const [inboxPageStack, setInboxPageStack] = useState([]);
  const [sentPageStack, setSentPageStack] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const dataResponse = await Promise.all([
        getClients(session.authToken),
        getContacts(session.authToken),
        getCandidates(session.authToken),
        getEmails(session.authToken, 'sent', ''),
        getEmails(session.authToken, 'inbox', ''),
      ]);

      setClients(dataResponse[0].data.clients);
      setContacts(dataResponse[1].data.contacts);
      setCandidates(dataResponse[2].data.candidates);

      dispatch({type: "INIT_SENT_EMAILS", payload: dataResponse[3].data.data});

      dispatch({type: "INIT_INBOX_EMAILS", payload: dataResponse[4].data.data});

      if (dataResponse[3].data.data.nextPageToken) {
        setSentPageStack([dataResponse[3].data.data.nextPageToken])
      }

      if (dataResponse[4].data.data.nextPageToken) {
        setInboxPageStack([dataResponse[4].data.data.nextPageToken])
      }
      setLoading(false);
    }
    dispatch({type: "SET_INDEX", payload: "7"});
    fetchData();
  // eslint-disable-next-line
  }, []);

  const handleOnClickAction = (email) => {
    setDetail(email);
    setDetailModalOpen(true)
  }

  const handleInboxPrevious = async () => {
    if (!reloading) {
      setReloading(true);
      let array = inboxPageStack;
      array.pop();
      let data;
      if (array.length === 1) {
        data = await getEmails(session.authToken, 'inbox', '');
      }
      else {
        data = await getEmails(session.authToken, 'inbox', array[array.length-2]);
      }
      setInboxPageStack(array);
      dispatch({type: "INIT_INBOX_EMAILS", payload: data.data.data});
      setReloading(false);
    }
  }

  const handleInboxNext = async () => {
    if (!reloading) {
      setReloading(true);
      const data = await getEmails(session.authToken, 'inbox', inboxPageStack[inboxPageStack.length-1]);
      setInboxPageStack([...inboxPageStack, ...[data.data.data.nextPageToken]]);
      dispatch({type: "INIT_INBOX_EMAILS", payload: data.data.data});
      setReloading(false);
    }
  }

  const handleSentPrevious = async () => {
    if (!reloading) {
      setReloading(true);
      let array = sentPageStack;
      array.pop();
      let data;
      if (array.length === 1) {
        data = await getEmails(session.authToken, 'sent', '');
      }
      else {
        data = await getEmails(session.authToken, 'sent', array[array.length-2]);
      }
      setSentPageStack(array);
      dispatch({type: "INIT_SENT_EMAILS", payload: data.data.data});
      setReloading(false);
    }
  }

  const handleSentNext = async () => {
    if (!reloading) {
      setReloading(true);
      const data = await getEmails(session.authToken, 'sent', sentPageStack[sentPageStack.length-1]);
      setSentPageStack([...sentPageStack, ...[data.data.data.nextPageToken]]);
      dispatch({type: "INIT_SENT_EMAILS", payload: data.data.data});
      setReloading(false);
    }
  }

  const renderDate = (email) => {
    return (
      <div>
        {moment(parseInt(email.internalDate)).format('DD/MM/YYYY')}
        <br/>
        {moment(parseInt(email.internalDate)).format('ddd HH:mm')}
      </div>
    )
  }

  const renderSubjectBody = (email) => {
    return(
      <div>
        <b>{email.subject}</b>
        <br/>
        {
        email.snippet.length > 75 ?
        parse(email.snippet.substring(0, 75))+"..."
        :
        parse(email.snippet)
        }
      </div>
    )
  }

  const renderPerson = (email) => {
    if (email.person) {
      const url = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/${email.person.type}/${email.person.id}.jpeg`;
      return(
        <span onClick={() => {
          navigate(`/${email.person.type}s/${email.person.id}`)
        }} style={{cursor: "pointer"}}>
        <CustomAvatar
          colourCode={email.person.firstname.charAt(0).toLowerCase()}
          char={`${email.person.firstname.charAt(0).toUpperCase()}${email.person.lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          size={30}
          src={url}
        />
        &nbsp;
        {`${email.person.firstname} ${email.person.lastname}`}
        </span>
      )
    }
    return(
      <div style={{color: '#ccc'}}>Person Not Found</div>
    )
  }

  const renderPersonType = (email) => {
    return(
      email.person ?
      <center><Tag color={email.person.type === 'contact' ? 'purple' : 'green'}>
        {email.person.type}
      </Tag></center>
      :
      null
    )
  }

  const renderAction = (email) => {
    return(
      <div style={flexCenterRight}>
        <Button size="small" onClick={() => {handleOnClickAction(email)}}>
          <Icon type="plus" /> Read More
        </Button>
      </div>
    )
  }

  const inboxColumns = [
    {
      title: 'Date',
      width: '12%',
      key: 'internalDate',
      render: (email) => renderDate(email)
    },
    {
      title: 'Subject/Body',
      width: '52%',
      key: 'subject',
      render: (email) => renderSubjectBody(email)
    },
    {
      title: '',
      width: '10%',
      key: 'tag',
      render: (email) => renderPersonType(email)
    },
    {
      title: 'Identify',
      width: '20%',
      key: 'person',
      render: (email) => renderPerson(email)
    },
    {
      title: '',
      width: '6%',
      key: 'action',
      render: (email) => renderAction(email)
    },
  ];

  const sentColumns = [
    {
      title: 'Date',
      width: '12%',
      key: 'internalDate',
      render: (email) => renderDate(email)
    },
    {
      title: 'Subject/Body',
      width: '52%',
      key: 'subject',
      render: (email) => renderSubjectBody(email)
    },
    {
      title: '',
      width: '10%',
      key: 'tag',
      render: (email) => renderPersonType(email)
    },
    {
      title: 'Identify',
      width: '20%',
      key: 'person',
      render: (email) => renderPerson(email)
    },
    {
      title: '',
      width: '6%',
      key: 'action',
      render: (email) => renderAction(email)
    },
  ];

  const EmailDetail = ({detail, contacts, candidates}) => {
    const renderPersonForm = (detail) => {
      const url = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/${detail.person.type}/${detail.person.id}.jpeg`;
  
      const handleOnCreateNewEventWithPerson = async (detail) => {
        const formResult = await form.validateFields();

        setCreating(true);
        const result = await copyEmail(
          session.authToken, 
          {
            email: detail, 
            formData: formResult,
          });
        setCreating(false);
  
        setDetailModalOpen(false);
        form.resetFields();
        setPersonType('');
  
        if (result.data.responseCode === 0) {
          message.success(result.data.message);
  
          setReloading(true);
          const sentResponse = await getEmails(session.authToken, 'sent', sentPageStack.length >= 2 ? sentPageStack[sentPageStack.length-2] : '');
          dispatch({type: "INIT_SENT_EMAILS", payload: sentResponse.data.data});
  
          const inboxResponse = await getEmails(session.authToken, 'inbox', inboxPageStack.length >= 2 ? inboxPageStack[inboxPageStack.length-2] : '');
          dispatch({type: "INIT_INBOX_EMAILS", payload: inboxResponse.data.data});
          setReloading(false);
        }
        else {
          message.error(result.data.message.toString());
        }
      }
  
      return(
        <React.Fragment>
        <Row>
          <Col span={7}>
            <Form.Item>
            {getFieldDecorator('eventtype', {
              rules: [{ required: true, message: 'Please select event type!' }],
              })(
              <Select
                  placeholder="Event Type"
                  style={{ width: 220 }}
              >
                {
                  eventsTypeArr.filter(i => i.name !== 'all').map(i => (
                  <Option key={i.name} value={i.name}>{i.text}</Option>
                  ))
                }
              </Select>
            )}
            </Form.Item>
          </Col>
  
          <Col span={4}>
            <div style={{marginTop: '7px'}}>
              save email with
            </div>
          </Col>
  
          <Col span={5}>
            <div style={{marginTop: '3px'}}>
            <CustomAvatar
              colourCode={detail.person.firstname.charAt(0).toLowerCase()}
              char={`${detail.person.firstname.charAt(0).toUpperCase()}${detail.person.lastname.charAt(0).toUpperCase()}`}
              charSize={12}
              size={30}
              src={url}
            />
            &nbsp;
            {`${detail.person.firstname} ${detail.person.lastname}`}
            </div>
          </Col>

          <Col span={5}>
            {
              detail.person.type === 'contact' ? (
                <Form.Item>
                {getFieldDecorator('candidate', {})(
                    <Select
                      placeholder="Select Candidate"
                      style={{ width: 220 }}
                      showSearch
                      optionFilterProp="label"
                    >
                      {candidates.map((i) => (
                        <Select.Option
                          label={`${i.firstname} ${i.lastname}`}
                          key={i.id}
                          value={i.id}
                        >
                          <>
                            <CustomAvatar
                              style={{marginTop: '-3px'}}
                              colourCode={i.firstname.charAt(0).toLowerCase()}
                              char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                              charSize={11}
                              size={26}
                              src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.id}.jpeg`}
                            />
                            &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                          </>
                        </Select.Option>
                      ))}
                    </Select>
                )}
                </Form.Item>
              ) : (
                <Form.Item>
                {getFieldDecorator('contact', {})(
                    <Select
                      placeholder="Select Contact"
                      style={{ width: 220 }}
                      showSearch
                      optionFilterProp="label"
                    >
                      {contacts.map((i) => (
                        <Select.Option
                          label={`${i.firstname} ${i.lastname}`}
                          key={i.id}
                          value={i.id}
                        >
                          <>
                            <CustomAvatar
                              style={{marginTop: '-3px'}}
                              colourCode={i.firstname.charAt(0).toLowerCase()}
                              char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                              charSize={11}
                              size={26}
                              src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.id}.jpeg`}
                            />
                            &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                          </>
                        </Select.Option>
                      ))}
                    </Select>
                )}
                </Form.Item>
              )
            }
          </Col>
        </Row>
        <Row>
          <Col span={21}>
            {
              detail.attachments.length > 0 ?
              <div style={{marginTop: '5px', marginBottom: '10px'}}>
                Attachments <i style={{color: "#bbb"}}>(tick checkbox if you'd like to save file)</i>
              </div>
              :
              <div style={{marginTop: '5px', color: '#bbb'}}>No attachment</div>
            }
            {
              detail.attachments.map((i, k) => (
                <div key={k}>
                  {getFieldDecorator(`attachment-${k}`, {
                    initialValue: false,
                    valuePropName: 'checked'
                  })(<Checkbox>
                      <Icon type="paper-clip" />{i.filename}
                     </Checkbox>)}
                </div>
              ))
            }
          </Col>
          <Col span={3}>
            <div style={flexCenterRight}>
              <Button type="primary" onClick={() => {handleOnCreateNewEventWithPerson(detail)}}>
                {
                  creating ?
                  <Icon type="loading" />
                  :
                  <Icon type="check" />
                }
                Save
              </Button>
            </div>
          </Col>
        </Row>
        </React.Fragment>
      )
    }

    const renderWithoutPersonForm = (detail) => {
      let fullname = "";
      let lastname = "";
      let firstname = "";
      let email = detail.source.match(/<(.+)>/);
  
      if (email) {
        email = email[1];
        fullname = detail.source.replace(email, "").replace(/ <>/, '').split(" ");
        lastname = fullname[fullname.length -1];
        fullname.pop();
        firstname = fullname.join(" ");
      }
      else{
        email = detail.source;
      }
  
      const handleOnCreateNewPerson = async () => {
        const formResult = await form.validateFields();
  
        setCreating(true);
        const result = await copyEmail(
          session.authToken, 
          {
            email: detail, 
            formData: formResult,
          });
        setCreating(false);
  
        setDetailModalOpen(false);
        form.resetFields();
        setPersonType('');
  
        if (result.data.responseCode === 0) {
          message.success(result.data.message);
  
          setReloading(true);
          const sentResponse = await getEmails(session.authToken, 'sent', sentPageStack.length >= 2 ? sentPageStack[sentPageStack.length-2] : '');
          dispatch({type: "INIT_SENT_EMAILS", payload: sentResponse.data.data});
  
          const inboxResponse = await getEmails(session.authToken, 'inbox', inboxPageStack.length >= 2 ? inboxPageStack[inboxPageStack.length-2] : '');
          dispatch({type: "INIT_INBOX_EMAILS", payload: inboxResponse.data.data});
          setReloading(false);
        }
        else {
          message.error(result.data.message.toString());
        }
      }
  
      return(
        <div>
          <Row>
            <Col span={7}>
              <Form.Item label="Event Type">
              {getFieldDecorator('eventtype', {
                rules: [{ required: true, message: 'Please select event type!' }],
                })(
                <Select
                    placeholder="Event Type"
                    style={{ width: 220 }}
                >
                  {
                    eventsTypeArr.filter(i => i.name !== 'all').map(i => (
                    <Option key={i.name} value={i.name}>{i.text}</Option>
                    ))
                  }
                </Select>
              )}
              </Form.Item>
            </Col>
  
            <Col span={5}>
              <Form.Item label="Person Type">
              {getFieldDecorator('persontype', {
                rules: [{ required: true, message: 'Please select person type!' }],
                })(
                <Select
                    onChange={(value) => {setPersonType(value)}}
                    placeholder="Person Type"
                    style={{ width: 150 }}
                >
                  <Option key={'contact'} value={'contact'}>Contact</Option>
                  <Option key={'candidate'} value={'candidate'}>Candidate</Option>
                </Select>
              )}
              </Form.Item>
            </Col>
  
            {
              personType === 'contact' ?
              <Col span={6}>
                <Form.Item label="Client">
                {getFieldDecorator('client', {
                  rules: [{ required: true, message: 'Please select client!' }],
                  })(
                  <Select
                      optionFilterProp={'label'}
                      showSearch={true}
                      placeholder="Client"
                      style={{ width: 200 }}
                  >
                    {
                      clients.map(i => (
                      <Option key={i.id} value={i.id} label={i.name}>
                        <CustomAvatar
                          style={{marginTop: '-3px'}}
                          colourCode={i.name.charAt(0).toLowerCase()}
                          char={`${i.name.charAt(0).toUpperCase()}`}
                          charSize={11}
                          size={26}
                          src={i.avatar}
                        />
                        &nbsp;{i.name}
                      </Option>
                      ))
                    }
                  </Select>
                )}
                </Form.Item>
              </Col>
              :
              null
            }
  
          </Row>
          <Row>
            <Col span={5}>
              <Form.Item  label="First Name">
                {getFieldDecorator('firstname', {
                  initialValue: firstname,
                  rules: [{ required: true, message: 'Please input first name!' }],
                })(
                  <Input autoComplete="off" disabled={creating} placeholder="First Name" />
                )}
              </Form.Item>
            </Col>
  
            <Col span={1} />
  
            <Col span={5}>
              <Form.Item label="Last Name">
                {getFieldDecorator('lastname', {
                  initialValue: lastname,
                  rules: [{ required: true, message: 'Please input last name!' }],
                })(
                  <Input autoComplete="off" disabled={creating} placeholder="Last Name" />
                )}
              </Form.Item>
            </Col>
  
            <Col span={1} />
  
            <Col span={7}>
              <Form.Item label="Email">
                {getFieldDecorator('email', {
                  initialValue: email,
                  rules: [
                    {
                      type: "email",
                      message: "Please input valid email!",
                    },
                    {
                      required: true,
                      message: "Please input email!"
                    }
                  ]
                })(
                  <Input autoComplete="off" disabled={creating} placeholder="Email" />
                )}
              </Form.Item>
            </Col>  
          </Row>
          <Row>
            <Col span={21}>
            {
              detail.attachments.length > 0 ?
              <div style={{marginTop: '5px', marginBottom: '10px'}}>
                Attachments <i style={{color: "#bbb"}}>(tick checkbox if you'd like to save file)</i>
              </div>
              :
              <div style={{marginTop: '5px', color: '#bbb'}}>No attachment</div>
            }
            {
              detail.attachments.map((i, k) => (
                <div key={k}>
                  {getFieldDecorator(`attachment-${k}`, {
                    initialValue: false,
                    valuePropName: 'checked'
                  })(<Checkbox>
                      <Icon type="paper-clip" />{i.filename}
                     </Checkbox>)}
                </div>
              ))
            }
            </Col>
            <Col span={3}>
              <div style={flexCenterRight}>
              <Button 
                disabled={detail.body === ''}
                type="primary" 
                onClick={handleOnCreateNewPerson}
              >
                {
                  creating ?
                  <Icon type="loading" />
                  :
                  <Icon type="check" />
                }
                Save
              </Button>
              </div>
            </Col>
          </Row>
        </div>
      )
    }

    const renderEmailBody = (detail) => {
      const body = new Buffer(detail.body, 'base64');
      return(
        <div>
          <p><b>{detail.box === 'inbox' ? "From:" : "To:"}</b> <span>{detail.source}</span></p>
          <p><b>Subject:</b> <span>{detail.subject}</span></p>
          <div>
            {
              body.toString() === '' && detail.bodyType !== 'calendar' ? (
                <Result
                  status="warning"
                  title="It seems like email body is empty, please contact system admin to report this issue."
                />
              ) : (
               <>
               {
                 body.toString() === '' && detail.bodyType === 'calendar' ? (
                  <Result
                    status="warning"
                    title="This is calendar event, you have to copy it from original email."
                  />
                 ) : (
                   <div style={{maxHeight: '400px',overflow: "auto"}}>
                     {parse(stripBody(body.toString()))}
                    </div>
                 )
               }
               </>
              )
            }
          </div>
        </div>
      )
    }

    return(
      <div>
        {
          detail && detail.person ?
          renderPersonForm(detail)
          :
          null
        }
        {
          detail && !detail.person ?
          renderWithoutPersonForm(detail)
          :
          null
        }
        <Divider />
        {detail ? renderEmailBody(detail) : null}
      </div>
    )
  }
    
  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <div>
      <Modal
        title="Email Detail"
        width={900}
        centered={true}
        closable={false}
        visible={detailModalOpen}
        footer={[
          <Button key="submit" onClick={() => {
            form.resetFields();
            setPersonType('');
            setDetailModalOpen(false);
          }}>
            <Icon type="close" />
            Close
          </Button>
        ]}
      >
        <EmailDetail detail={detail} contacts={contacts} candidates={candidates} />
      </Modal>

      <Tabs type="card">
        <TabPane tab={
          <span><FontAwesomeIcon icon={faInbox} /> Inbox</span>
        } key="inbox">
          {
            emails.inbox ?
            <div>
              <Spin spinning={reloading} indicator={<Icon type="loading" />}>
              <Table
                pagination={false}
                size="small"
                columns={inboxColumns}
                dataSource={emails.inbox.emails}
                rowKey="id"
              />
              </Spin>
              <br/>
              <div style={flexCenterRight}>
                Page: {inboxPageStack.length === 0 ? 1 : inboxPageStack.length}
                &nbsp;&nbsp;
                <Button onClick={handleInboxPrevious}
                  disabled={inboxPageStack.length > 1 ? false : true}
                  size="small">{'<<'}</Button>
                &nbsp;&nbsp;
                <Button onClick={handleInboxNext}
                  disabled={inboxPageStack[inboxPageStack.length-1] ? false : true}
                  size="small">{'>>'}</Button>
              </div>
            </div>
            :
            null
          }
        </TabPane>
        <TabPane tab={
          <span><FontAwesomeIcon icon={faPaperPlane} /> Sent</span>
        } key="sent">
          {
            emails.sent ?
            <div>
              <Spin spinning={reloading} indicator={<Icon type="loading" />}>
              <Table
                pagination={false}
                size="small"
                columns={sentColumns}
                dataSource={emails.sent.emails}
                rowKey="id"
              />
              </Spin>
              <br/>
              <div style={flexCenterRight}>
                Page: {sentPageStack.length === 0 ? 1 : sentPageStack.length}
                &nbsp;&nbsp;
                <Button onClick={handleSentPrevious}
                  disabled={sentPageStack.length > 1 ? false : true}
                  size="small">{'<<'}</Button>
                &nbsp;&nbsp;
                <Button onClick={handleSentNext}
                  disabled={sentPageStack[sentPageStack.length-1] ? false : true}
                  size="small">{'>>'}</Button>
              </div>
            </div>
            :
            null
          }
        </TabPane>
      </Tabs>
    </div>
  );
}

const EmailsForm = Form.create({ name: 'emails' })(Emails);

export default EmailsForm;
